import AddToCalendar from 'components_v1/addToCalendar/AddToCalendar'
import LikesAndDislikes from 'components_v1/LikesAndDislikes'
import ClassPageActions from 'components_v1/planEntry/ClassPageActions'
import PlaylistButton from 'components_v1/playlist/PlaylistButton'
import { capitalize } from 'components_v2/common'
import React, { useContext, useEffect, useState } from 'react'
import { ResponsiveSVG } from 'ui/acro'
import DuplicateIcon from '../../images/latest/duplicate_icon.svg'
import styled from 'styled-components'
import heartSVG from '../../../assets/images/heart.svg'
import heartFilledSVG from '../../../assets/images/heartFilled.svg'
import ShareNative from './ShareNative'
import { axios } from 'api'
import { camelToSnake } from 'utils'
import { ClassViewContext } from 'components_v2/page_context'

const HeartDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  align-items: center;
  font-family: Proxima-nova;
`
export const HeartIconComponent = ({
  onClick = () => {},
  isFilled = false,
  id
}) => (
  <HeartDiv
    onClick={onClick}
    id={id}
    className='pdp-action pdp-action--schedule log-class-button'
  >
    <ResponsiveSVG
      SVG={isFilled ? heartFilledSVG : heartSVG}
      style={{
        cursor: 'pointer'
      }}
      width='24px'
      height='24px'
    />
    <span>Save</span>
  </HeartDiv>
)

const Main = styled.div`
  @media screen and (min-width: 768px) {
    width: fit-content !important;
    margin-top: 26px;
    .pdp-class-actions__scroll {
      display: flex !important;
      flex-wrap: nowrap;
      gap: 16px;
    }
  }
  .pdp-class-actions__end-wrap {
    display: flex !important;
    flex-direction: column;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    align-self: center;
    min-width: max-content;
    overflow: visible;
    position: relative;
    z-index: 5;

    @media (min-width: 768px) {
      display: none !important;
    }

    .pdp-class-pdp-more-mobile {
      display: flex !important;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
    }
  }
`

const ClassActions = ({ plan_entry, user, playlistIds }) => {
  const { fetchData = () => {}, setClassState = () => {} } =
    useContext(ClassViewContext)

  const [saveId, setSaveId] = useState(plan_entry?.favorite?.id)
  const [loading, setLoading] = useState(false)
  useEffect(() => setSaveId(plan_entry?.favorite?.id), [plan_entry])
  const classDetails = {
    id: plan_entry?.id,
    style: plan_entry?.style,
    title: plan_entry?.title,
    availabilityGating: plan_entry?.availabilityGating
  }
  const video = plan_entry?.video
  const plan = plan_entry?.plan
  const videoDetails = { title: video?.title || '' }
  const seriesDetails = { title: plan?.title }
  const coachList = plan?.coaches?.map((c) => ({
    slug: c?.coachInfo?.slug,
    fullName: [
      c?.coachInfo?.user?.firstName,
      c?.coachInfo?.user?.lastName
    ].join(' ')
  }))
  const scrollToComment = () => {
    var el =
      document.getElementById('class-pdp-post-comment') ||
      document.querySelector('.post-comment')
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
  }
  window.scrollToComment = scrollToComment

  const handleSave = async () => {
    if (loading) return
    let id = null
    try {
      setLoading(true)
      if (Boolean(saveId)) {
        id = saveId
        setSaveId(null)
        await axios.delete(`/favorites/${id}`)
      } else {
        setSaveId(1)
        const res = await axios.post('/favorites', {
          plan_entry_id: plan_entry.id
        })
        if (res.data.id) {
          setSaveId(res.data.id)
          window.dataLayer.push(camelToSnake(res?.data?.ga4Events))
        } else {
          setSaveId(null)
          fetchData()
        }
      }
    } catch (err) {
      console.log(err)
      id && setSaveId(id)
      fetchData()
    } finally {
      setLoading(false)
    }
  }
  return (
    <>
      {video && plan_entry?.unlocked && user && (
        <Main className='new-favorite-button-inline pdp-class-actions'>
          <div className='pdp-class-actions__scroll'>
            <HeartIconComponent
              onClick={handleSave}
              isFilled={Boolean(saveId)}
              id='class-favourite-button'
            />
            <div className='pdp-action pdp-action--schedule'>
              <AddToCalendar
                videoThumbnail={video?.thumbnail?.url}
                humanDuration={plan_entry?.humanDuration}
                title={plan_entry.title}
                difficultyLevel={capitalize(plan_entry?.difficultyLevel)}
                coaches={coachList}
                style={plan_entry.style}
                availabilityGating={plan_entry?.availabilityGating}
                seriesName={plan?.title}
                videoTitle={video?.title}
                equipments={plan_entry?.equipments || []}
                planEntryUrl={plan_entry?.planEntryUrl}
              />
            </div>

            <div
              className='pdp-action pdp-action--playlist'
              data-pdp-action='playlist'
            >
              <PlaylistButton
                classDetails={classDetails}
                playlistIds={playlistIds}
              />
            </div>

            <div className='pdp-action pdp-action--like likes-dislikes'>
              <LikesAndDislikes
                handleChange={(data) =>
                  setClassState((state) => ({
                    ...state,
                    likes: data?.likes,
                    userLiked: data?.userLiked
                  }))
                }
                classDetails={classDetails}
                videoDetails={videoDetails}
                seriesDetails={seriesDetails}
                username={user?.username}
                createdAt={user?.createdAt}
                type={'CLASS'}
                coaches={coachList}
              />
            </div>
            <div
              className='pdp-action pdp-action--comment pdp-class-actions__comment-desktop'
              onClick={scrollToComment}
              role='button'
              tabIndex={0}
              onKeyDown={(event) => {
                if (event.key === 'Enter' || event.key === ' ') {
                  event.preventDefault()
                  scrollToComment()
                }
              }}
            >
              <div className='log-class-button'>
                <ResponsiveSVG SVG={DuplicateIcon} width='25px' height='25px' />
                <span>Comment</span>
              </div>
            </div>
            <div className='pdp-class-actions__end-wrap'>
              <ClassPageActions
                saved={Boolean(saveId)}
                class_entry_title={plan_entry.title}
              />
            </div>
            <ShareNative plan_entry={plan_entry} shareKind='class' />
          </div>
        </Main>
      )}
    </>
  )
}

export default ClassActions
